export const telegramKeys = {
    all: ['telegram'],
    botStatus: (username) => [...telegramKeys.all, 'bot-status', username],
};
